// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__6xdL9","nopadding":"styles_nopadding__2DnF0","wrapper":"styles_wrapper__3SpfV","spin":"styles_spin__B9XTq"};